import * as React from "react"
import { Box, CssBaseline, ThemeProvider } from '@mui/material';
// import WelcomeMat from "components/WelcomeMat";
// import { MastheadContext } from 'contexts/MastheadContext';
import Header from 'components/Header';
import Footer from 'components/Footer';
import theme from 'utils/theme';
import SkipNavigationLink from 'components/SkipNavigationLink';
import { MAIN_CONTENT_ID } from 'components/SkipNavigationLink';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import Zeek from 'components/Zeek';

import 'styles/app.scss';

const Layout = props => {
	const { children } = props;
	const [zeekActive, setZeekActive] = React.useState(false);
	const { pageContext } = props;

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline>
				<GoogleReCaptchaProvider reCaptchaKey={process.env.RECAPTCHA_SITE_KEY}>
					<SkipNavigationLink />
					{ pageContext?.includeHeader !== false && <Header /> }
					<section id={MAIN_CONTENT_ID} aria-label="Start of content"></section>
					<Box component="main" className={`page-${props.location.pathname.replace(/\//gm, "")}`}>
						{children}
					</Box>
					{ pageContext?.includeZeek !== false && <Zeek className="desktop" active={zeekActive} setActive={setZeekActive} /> }
					{ pageContext?.includeFooter !== false && <Footer /> }
				</GoogleReCaptchaProvider>
			</CssBaseline>
		</ThemeProvider>
	)
}

export default Layout;